import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { PageHeader, Spinner, useApiQuery } from '@/modules/common';
import { Routes } from '@/router/routes';

import { EventsTable } from '../components';
import { EventsResponse } from '../types';

export const EventsPage: FC = () => {
  const navigate = useNavigate();

  const { isFetching, data } = useApiQuery<EventsResponse>(
    '/events?pageSize=1000',
    {
      queryKey: ['events'],
      initialData: {
        items: [],
      },
    }
  );

  const redirectToEventDetails = (item) => {
    navigate(Routes.EventDetails.replace(':id', item.id));
  };

  return (
    <div>
      <PageHeader
        title="Events"
        actions={[
          <Link
            to={Routes.NewEvent}
            key="new-event"
            data-testid="add-new-event-link"
          >
            <Button disabled={isFetching} data-testid="add-new-event-button">
              <PlusSquareIcon />
              Add new event
            </Button>
          </Link>,
        ]}
      />

      {isFetching ? (
        <Spinner />
      ) : (
        <EventsTable data={data.items} onClick={redirectToEventDetails} />
      )}
    </div>
  );
};
